<template>
  <div>
    <swiper
      v-if="Array.isArray(options) && slides == 1"
      ref="mySwiper"
      :options="swiperOptionsSingle"
      class="swiper"
      style="line-height: 0"
    >
      <swiper-slide v-for="slide in options" :key="slide.business_id">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <!-- <v-img width="100%" class="mx-auto" :src="slide.imageUrl"></v-img> -->
            <img
              :data-src="slide.imageUrl"
              :alt="slide.title"
              class="mx-auto swiper-lazy"
              style="width: 100%"
            >
          </v-flex>
          <v-flex
            :class="{ 'pa-5': $vuetify.breakpoint.smAndDown }"
            :style="`${
              $vuetify.breakpoint.smAndDown ? 'min-height: 295px' : ''
            }`"
            xs12
            md6
            class="listingTextSection"
          >
            <div class="listingTextContent">
              <img
                :src="getLogoUrl(slide.business_id)"
                :alt="slide.title"
                style="width: 300px; height: 200px;"
                class="mx-auto swiper-lazy"
              >

              <h1 style="color: #162c47">
                {{ slide.title }}
              </h1>
              <p style="color: #162c47">{{ slide.text }}</p>
              <v-btn
                class="lightBtn text-capitalize elevation-0 mx-0 mt-4 py-3 px-4"
                @click="() => $router.push(`/business/${slide.business_id}`)"
              >
                Find out more
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </swiper-slide>
    </swiper>
    <swiper
      v-else-if="Array.isArray(options)"
      ref="mySwiper"
      :options="swiperOptions"
      @slideChange="handleSlideChange"
    >
      <swiper-slide
        v-for="(slide, index) in visibleOptions"
        :key="index"
      >
        <div style="width: 50%; margin: auto">
          <img
            :data-src="slide.imageUrl"
            style="width: 100%"
            class="mx-auto swiper-lazy"
          >
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

import Vue from 'vue'
import ApiV2 from '@/apiV2'

import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Lazy
} from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.css'

SwiperClass.use([Pagination, Mousewheel, Autoplay, Lazy])
Vue.use(getAwesomeSwiper(SwiperClass))

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
let vm = []

export default {
  name: 'Carrousel',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    options: {
      default: null
    },
    slides: {
      type: Number,
      default: 3
    },
    swiperID: {
      default: null
    }
  },
  data () {
    return {
      impactBuyerLogoUrls: {},
      currentStart: 0,
      itemsPerPage: 10,
      swiperOptionsSingle: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,

        autoplay: {
          delay: 7000,
          disableOnInteraction: true
        },
        breakpoints: {
          600: {},
          960: {},
          1264: {}
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1
        }
        // Some Swiper option/callback...
      },
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 60
          },
          960: {
            spaceBetween: 40
          },
          1264: {
            slidesPerView: this.slides,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
          loadPrevNextAmount: 10,
          loadPrevNext: true
        }
        // Some Swiper option/callback...
      }
    }
  },
  computed: {
    visibleOptions () {
      return this.options.slice(0, this.currentStart + this.itemsPerPage)
    }
  },
  watch: {
    options: {
      handler (newListings, oldListings) {
        if (this.slides !== 1) return
        newListings.forEach(this.getImpactBuyerLogoForFeaturedListing)
      },
      immediate: true
    }
  },
  created () {
    vm.push(this)
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.mySwiper.$swiper.slideTo(3, 1000, false)
      // this.$refs.mySwiper.$swiper.autoplay.stop();
      // this.$refs.mySwiper.$swiper.autoplay.start();
    })
    // if (this.slides == 1) {
    //   this.options.forEach(this.getImpactBuyerLogoForFeaturedListing);
    // }
  },
  methods: {
    getImpactBuyerLogoForFeaturedListing: function (featuredListing) {
      if (featuredListing.business_id in this.impactBuyerLogoUrls) return
      ApiV2.get('ImpactBuyer/GetImpactBuyerLogoUrl', {
        params: { businessId: featuredListing.business_id }
      })
        .then(r => {
          this.$set(this.impactBuyerLogoUrls, featuredListing.business_id, r.data)
        })
    },
    getLogoUrl (businessId) {
      // Return the URL or a placeholder if the URL is not available
      return this.impactBuyerLogoUrls[businessId] || ''
    },
    handleSlideChange () {
      const swiper = this.$refs.mySwiper.$swiper;
      this.currentStart = swiper.activeIndex; // Use realIndex to get the actual slide index in loop mode

      if (this.currentStart > this.options.length)
      {
        this.currentStart = this.options.length
        return;
      }
      this.$nextTick(() => {
        swiper.update();
      });
    }
  }
}
</script>

<style scoped>
  h1 {
    font-weight: bold !important;
    color: white;
    font-size: 3rem;
  }

  .darkBtn {
    background-color: #162c47 !important;
    color: white !important;
    font-weight: lighter;
  }

  .lightBtn {
    background-color: #4ac7e9 !important;
    color: white !important;
    font-weight: lighter;
  }

  .listingTextSection {
    /*background-color: #4cc7e8;*/
    background-color: white;
    color: #162c47;
    display: flex;
    justify-content: space-between;
    min-height: 100%;
  }

  .listingTextContent {
    max-width: 500px;
    margin: auto;
  }

  .listingTextContent p {
    line-height: 1.2;
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 2rem !important;
    }
  }
</style>
